/**
 * CMS Management Page
 *
 * Purpose: Admin page for managing CMS content
 */

export function CMSPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">CMS Management</h1>
        <p className="mt-2 text-gray-600">Manage CMS content</p>
      </div>

      <div className="bg-white rounded-lg border border-gray-300 p-6">
        <p className="text-gray-600">
          Use FAQ and About Us in the sidebar to manage CMS content.
        </p>
      </div>
    </div>
  )
}

